import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { useUsageTracker } from '../../hooks/useUsageTracker';

const PrivateRoute: React.FC = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const role = localStorage.getItem(USER_ROLE_KEY);
  const isStudentSession = Boolean(token) && role !== 'ep' && role !== 'admin' && role !== 'parent';
  const location = useLocation();
  const path = location.pathname;
  const shouldUseLayout = !(
    path === '/chat' ||
    path.startsWith('/exam/') ||
    path === '/vad' ||
    path === '/zaptalk-mood-tracker'
  );
  useUsageTracker({ enabled: isStudentSession });

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (role === 'ep') {
    return <Navigate to="/ep-dashboard" replace />;
  }

  if (!shouldUseLayout) {
    return <Outlet />;
  }

  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default PrivateRoute;
